import React from 'react';
import {graphql} from 'react-apollo';
import { Spinner, Message } from 'dab-component-lib';
import {basicPage} from '../../queries';
import I18n from '../../I18n/I18n';

import { GridContainerStyle, ErrorStyle, LoadingStyle } from '../../utils/style-utils';
import { PrivacyStyle } from './style';

class Policy extends React.Component {

  render() {
    const {basicPage: {loading, error, pagebytypeGraphql1View}} = this.props;

    if (loading) {
      return (
        <LoadingStyle>
          <Spinner size={150}/>
        </LoadingStyle>
      );
    }

    if (error || (!loading && !error && !pagebytypeGraphql1View.results.length > 0)) {
      return (
        <ErrorStyle>
          <Message title={I18n.t('errors.pageLoadingError')}/>
        </ErrorStyle>
      );
    }

    return (
      <GridContainerStyle>
        <PrivacyStyle>
          <div dangerouslySetInnerHTML={{__html:
            pagebytypeGraphql1View.results[0].body.processed}}></div>
        </PrivacyStyle>
      </GridContainerStyle>
    );
  }
}

export default graphql(
  basicPage, {
    name: 'basicPage',
    options: props => ({
      variables: {
        type: "1"
      }
    })
  }
)(Policy);


// WEBPACK FOOTER //
// ./src/components/policy/index.js